import React from 'react';
import {useNavigate} from 'react-router-dom';
import {Link} from '@mui/material'
import PaginatedTable from '../components/PaginatedTable';
import {httpRequest} from '../services/httpService';
import {IconButton, TableCell, TableRow, Typography} from '@mui/material';
import Grid from '@mui/material/Grid2'
import AddIcon from '@mui/icons-material/Add';
import SearchField from '../components/SearchField';
import {useSnackbar} from "../contexts/SnackbarContext";
import {toLocalDateTimeString} from "../utils/dateUtils";
import { EmptyGuid } from '../utils/constants';

export default function Visits() {
    const navigate = useNavigate();
    const showSnackbar = useSnackbar();

    const fetchVisits = async (page, rowsPerPage, search) => {
        const skip = page * rowsPerPage;
        const take = rowsPerPage;
        const response = await httpRequest('/api/visit/list', {params: {skip, take, search}}, showSnackbar);
        return {data: response.data, totalCount: response.totalItems};
    };

    const renderVisitRow = (visit, onRowClick) => (
        <TableRow
            key={visit.id}
            hover
            style={{cursor: 'pointer'}}
            onClick={() => onRowClick(visit)}
        >
            <TableCell>{toLocalDateTimeString(visit.time)}</TableCell>
            <TableCell>{visit.employeeName}</TableCell>
            <TableCell>
                <Link
                    to={`/clients/${visit.clientID}`}
                    onClick={(event) => event.stopPropagation()}
                >
                    {visit.clientName}
                </Link>
            </TableCell>
            <TableCell>{visit.petType}</TableCell>
            <TableCell>
                <Link
                    to={`/pets/${visit.petID}`}
                    onClick={(event) => event.stopPropagation()}
                >
                    {visit.petName}
                </Link>
            </TableCell>
        </TableRow>
    );

    const handleRowClick = (visit) => {
        navigate(`/visits/${visit.id}`);
    };

    return (
        <PaginatedTable
            fetchData={fetchVisits}
            headers={['Fecha', 'Empleado', 'Cliente', 'Especie', 'Mascota']}
            renderRow={renderVisitRow}
            onRowClick={handleRowClick}
            toolbar={
                <Grid
                    container
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        width: '100%',
                    }}
                >
                    <Grid sx={{display: 'flex', alignItems: 'center', padding: 1}}>
                        <Typography variant="h5">Visitas</Typography>                        <IconButton color="primary" onClick={() => handleRowClick({ id: EmptyGuid })}>
                            <AddIcon/>
                        </IconButton>
                    </Grid>
                    <Grid size={{sm:6, md:6, lg:4}} sx={{mr: 2}}>
                        <SearchField helperText="Buscar (dueño, teléfono, mascota)"/>
                    </Grid>
                </Grid>
            }
        />
    );
}

